import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _13_WATER_CONDITION_REGULATION:Partial<EcosystemServiceModel> ={
  id:'water-condition-regulation',
  pos:13,
  image: "/images/ecoservices/water_condition_regulation.jpg",
  code: ["2.2.5.1"],
  unit:'water condition regulation',
  assetType:'other',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'sustitutionCosts',
      name:"Sustitution Costs",
      unit: "m3",
      element: "Water",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
